import { env } from '@web/utils/env';

export const DISCORD_LINK = 'https://discord.com/invite/prsnjourney';
export const INSTAGRAM_LINK =
  'https://www.instagram.com/personajourney.official/';
export const TWITTER_LINK = 'https://x.com/persona_journey';
export const TELEGRAM_LINK = 'https://t.me/personajourney';
export const TIKTOK_LINK = 'https://www.tiktok.com/@persona.journey';
export const YOUTUBE_LINK = 'https://www.youtube.com/@PersonaJourney';
export const GIPHY_LINK = 'https://giphy.com/personajourney';

// Ecosystem Links
export const MC_LINK = 'https://mc.personajourney.io/';
export const HANA_STUDIOS_LINK = 'https://hanastudios.ai/';
export const CLOUT_CHASE_LINK = 'https://clout.hanapersona.ai/';
export const HANA_LINK = 'https://hanapersona.ai/';
export const UNAGI_GAMES_LINK = 'https://www.unagi.games/';
export const RECORDS_NETWORK_LINK = 'https://records.network/';
export const IMAGINE_LINK = 'https://imagine.personajourney.io/';

export const UNA_FLEX_LINK = 'https://unaflex.personajourney.io/';
export const BRAND_ASSETS_LINK = '/brand';

export const OPENSEA_PERSONA_ETH =
  env.ENVIRONMENT === 'release'
    ? 'https://opensea.io/collection/persona'
    : 'https://testnets.opensea.io/collection/test-14586';

export const OPENSEA_PERSONA_BASE =
  env.ENVIRONMENT === 'release'
    ? 'https://opensea.io/collection/persona-base'
    : 'https://testnets.opensea.io/collection/persona-13';

export const PERSONA_NFT_STORAGE =
  'https://storage.googleapis.com/persona-nfts-public';

export const TIMEFALL_VALLEY_CAFE = 'https://persona-gm.vercel.app/';

const OPENSEA_HOST =
  env.ENVIRONMENT === 'release'
    ? 'https://opensea.io'
    : 'https://testnets.opensea.io';

const OPENSEA_ETH_CHAIN_SLUG =
  env.ENVIRONMENT === 'release' ? 'ethereum' : 'sepolia';

// Canonical Ethereum-side OpenSea contract for the PERSONA collection. NOT
// the on-chain ERC-721 contract — OpenSea indexes the collection under a
// wrapped/proxy contract and item pages only resolve when this address is
// in the URL. Base tokens are bridged representations of the same persona
// so we always link to the Ethereum-side item page.
const OPENSEA_PERSONA_CONTRACT = '0xbabafdd8045740449a42b788a26e9b3a32f88ac1';

export function buildOpenSeaItemUrl(
  tokenId: bigint | number | string,
): string {
  return `${OPENSEA_HOST}/item/${OPENSEA_ETH_CHAIN_SLUG}/${OPENSEA_PERSONA_CONTRACT}/${tokenId}`;
}
